module.exports = __webpack_public_path__ + "img/USDC.1250ede0.png";